import { HabitatInsightsMetric, HabitatInsightsProcessingStatus, HabitatInsightsTileLayer } from 'src/shared/types';

export enum ChartDataStatus {
    READY = 'Ready',
    PROCESSING = 'Processing',
    NO_DATA = 'NoData',
    ERROR = 'Error',
}

const LAYER_FAILED_FALLBACK_DETAIL = 'Layer processing failed without a reported reason.';

type GetChartDataStatusProps = {
    metrics: HabitatInsightsMetric[] | null | undefined;
    metric: string;
    year: string | number;
};

export const findLayers = (
    metrics: HabitatInsightsMetric[] | null | undefined,
    metric: string,
    year: string | number
): HabitatInsightsTileLayer[] =>
    (metrics || [])
        .filter(entry => entry?.metric === metric)
        .flatMap(entry => entry.layers || [])
        // Coerced: layer years are typed string but arrive numeric.
        .filter(layer => String(layer.year) === String(year));

export const getChartDataStatus = (props: GetChartDataStatusProps): { status: ChartDataStatus; detail?: string } => {
    const { metrics, metric, year } = props;

    const layers = findLayers(metrics, metric, year);
    if (!layers.length) {
        return { status: ChartDataStatus.NO_DATA };
    }

    const layer = layers.find(entry => entry.status === HabitatInsightsProcessingStatus.READY) || layers[0];

    switch (layer.status) {
        case HabitatInsightsProcessingStatus.READY:
            return { status: ChartDataStatus.READY };
        case HabitatInsightsProcessingStatus.NO_DATA:
            return { status: ChartDataStatus.NO_DATA };
        case HabitatInsightsProcessingStatus.ERROR:
            return { status: ChartDataStatus.ERROR, detail: layer.errorMessage || LAYER_FAILED_FALLBACK_DETAIL };
        default:
            return { status: ChartDataStatus.PROCESSING };
    }
};
